import './App.css';
import React from 'react';
import ReactDOM from 'react-dom';

let isMoveImg = false;
let imageObj = null ;
let gMouseDownX = 0;
let gMouseDownY = 0;
let gMouseDownOffsetX = 0;
let gMouseDownOffsetY = 0;
let currentZoom = 1;
let minZoom = 0.05;
let maxZoom = 30.0;
let zoomStep = 0.05;
let pickedImg = false;

function $(id){ return document.getElementById(id); }

function App() {
  return (
    <div className="App" id="App" onWheel={onZoomImg} onClick={onClickBlankRegion}>
      <button id="editorButton" onClick={onEditorButtonDown}>viewing</button>
      <label id="current-file"> NAN </label>
      <input type="file" id="fileToUpload" className="fileToUpload" onChange={chooseFile}></input>
      <br></br>
      <div id="imgList"></div>
    </div>
  );
}

function onEditorButtonDown()
{
  console.log($('editorButton').innerHTML)
  let body = document.querySelector('body');
  if( $('editorButton').innerHTML === 'viewing' )
  {
    $('editorButton').innerHTML = 'deleting';
    body.style.cursor = 'not-allowed';
  }
  else
  {
    $('editorButton').innerHTML = 'viewing';
    body.style.cursor = 'default';
  }
}

function onZoomImg(e)
{
  console.log( "onZoomImg: ", e );
  // Zoom in or out based on the scroll direction
  let direction = e.deltaY > 0 ? -1 : 1;
  zoomImage(direction);
}

function onClickBlankRegion(e)
{
  console.log("onClickBlankRegion, imageObj: ", imageObj, ", pickedImg: ", pickedImg, ", e: ", e);
  if( $('editorButton').innerHTML === 'deleting' && $('imgList').contains( e.target ) )
  {
    let pickedImg = e.target;
    if( pickedImg )
    {
      $('imgList').removeChild( pickedImg );
      removeMouseMove();
    }
  }
  else if( imageObj !== null && pickedImg === false )
  {
    removeMouseMove();
  }
}

function zoomImage(direction) {
  if( null === imageObj )
  {
    return ;
  }
  let newZoom = currentZoom + direction * zoomStep;

  // Limit the zoom level to the minimum and maximum values
  if (newZoom < minZoom || newZoom > maxZoom) {
      return;
  }

  currentZoom = newZoom;

  // Update the CSS transform of the image to scale it
  imageObj.style.transform = 'scale(' + currentZoom + ')';
}

function chooseFile()
{
  var files = $("fileToUpload").files;
  if( files === undefined || files === "" || files.length <= 0 )
  {
      console.log("please choose file");
      return false;
  };

  console.log( "file name: " + files[0].name );
  createImg(files[0]);
}

function getObjectURL(file) {
  var url = null ;
  if (window.createObjectURL !== undefined) { // basic
      url = window.createObjectURL(file) ;
  } else if (window.URL !== undefined) { // mozilla(firefox)
      url = window.URL.createObjectURL(file) ;
  } else if (window.webkitURL !== undefined) { // webkit or chrome
      url = window.webkitURL.createObjectURL(file) ;
  }
  return url ;
}

function createImg(file)
{
  let url = getObjectURL(file);
  let obj = document.createElement("img");
  obj.src = url;
  obj.onclick = initialClick;
  obj.className = "img";
  obj.style.zIndex = 0;
  obj.id = file.name;
  $('imgList').appendChild( obj );

  // let obj = <img className='img' 
  // src={url}
  // onMouseDown={initialClick}
  // //onMouseUp={removeMouseMove}
  // alt='img'>
  // </img>
  //ReactDOM.render( obj, $('imgList') );
  return obj;
}

function moveImg(e){
  //console.log( "imageObj: ", imageObj )
  if( imageObj )
  {
    let topAmount = e.clientY - gMouseDownOffsetY;
    imageObj.style.top = topAmount + 'px';
    let leftAmount = e.clientX - gMouseDownOffsetX;
    imageObj.style.left = leftAmount + 'px';
  }
  pickedImg = false;
}

function removeMouseMove()
{
  console.log( "removeMouseMove, isMoveImg: ", isMoveImg );
  document.removeEventListener("mousemove", moveImg);
  isMoveImg = false;
  if( imageObj )
  {
    imageObj.style.zIndex = 0;
  }
  imageObj = null;
}

function initialClick(e) {
  console.log( isMoveImg, ", e: ", e.target.id )
  pickedImg = true;
  if(isMoveImg){
    removeMouseMove();
    return;
  }
  
  isMoveImg = !isMoveImg;
  imageObj = e.currentTarget;
  imageObj.style.zIndex = 1;
  document.addEventListener("mousemove", moveImg, false);

  //The following block gets the X offset (the difference between where it starts and where it was clicked)
  gMouseDownX = e.clientX;
  gMouseDownY = e.clientY;

  let leftPart = "";
  if(!imageObj.style.left)
      leftPart+="0px";    //In case this was not defined as 0px explicitly.
  else
      leftPart = imageObj.style.left;
  let leftPos = leftPart.indexOf("px");
  let leftNumString = leftPart.slice(0, leftPos); // Get the X value of the object.
  gMouseDownOffsetX = gMouseDownX - parseInt(leftNumString,10);
  console.log( parseInt(leftNumString,10), ", ", gMouseDownOffsetX )

  //The following block gets the Y offset (the difference between where it starts and where it was clicked)
  let topPart = "";
  if(!imageObj.style.top)
      topPart+="0px";     //In case this was not defined as 0px explicitly.
  else
      topPart = imageObj.style.top;
  let topPos = topPart.indexOf("px");
  let topNumString = topPart.slice(0, topPos);    // Get the Y value of the object.
  gMouseDownOffsetY = gMouseDownY - parseInt(topNumString,10);

  $("current-file").innerHTML = e.target.id;
  console.log( "imageObj.name: ", e.target.id );
}

export default App;
